const Input = ({label, value, onChange, ...props}: {
  label: string, 
  value: string, 
  onChange: (value: string) => void,
  [key: string]: any
}) => {
    return (
        <div>
            <label>{label}</label>
            <input 
                className="w-full px-4 py-3 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                {...props}
            />
        </div>
    )
}

export default Input;